export type MotionEase = [number, number, number, number];

/** Gentle ease-out, useful for restrained hover and small entrance motion. */
export const EASE_OUT_QUAD: MotionEase = [0.25, 0.46, 0.45, 0.94];

/** Primary product ease-out: responsive at the start, soft at rest. */
export const EASE_OUT_QUART: MotionEase = [0.165, 0.84, 0.44, 1];

/** Strong ease-out for larger surfaces that need to settle quickly. */
export const EASE_OUT_QUINT: MotionEase = [0.23, 1, 0.32, 1];

/** Strongest ease-out, reserved for rare hero/marketing reveals. */
export const EASE_OUT_EXPO: MotionEase = [0.19, 1, 0.22, 1];

/** Natural movement curve for elements that are already on screen. */
export const EASE_IN_OUT_QUART: MotionEase = [0.77, 0, 0.175, 1];

export const MOTION_DURATION = {
  micro: 0.15,
  fast: 0.18,
  normal: 0.22,
  slow: 0.3,
  page: 0.36,
} as const;
